import React from 'react'

type Props = {
  name: string
  action: string
  className?: string
}

const Form: React.FC<Props> = ({ children, name, action, className }) => {
  return (
    <form
      name={name}
      action={action}
      method="POST"
      data-netlify="true"
      data-netlify-recaptcha="true"
      className={className}
    >
      <input type="hidden" name="form-name" value={name} />
      {children}
    </form>
  )
}

export default Form
